export const EMAIL = 'email';
export const PHONE = 'phone';
export const NAME = 'name';
export const PASTE_ADDRESS = 'pasteAddress';
export const COMPANY = 'company';
export const LINE1 = 'line1';
export const LINE2 = 'line2';
export const CITY = 'city';
export const STATE = 'state';
export const COUNTRY = 'country';
export const POSTAL_CODE = 'postalCode';
